
  import echarts from 'echarts';
  import {Component, Vue} from "vue-property-decorator";
  import dataBox from "@/views/dashboard/components/dataBox.vue";
  import dataReport from "@/views/dashboard/components/dataReport.vue";
  import {getOu} from "@/utils/cookies";

  @Component({
    name:'StoreDashboard',
    components:{
      dataBox,
      dataReport
    }})
  export default class StoreDashboard extends Vue {

    get simpleParameter():any{
      return {
        orgId: (this.$store.getters['user/ouId']),
        onlyMe:true
      }
    }

    // 构建年度报表的API参数
    buildYearlyReportApiParameters(year:number):any{
      const parameters = {
        startMonth:1,
        endMonth:12,
        startYear:year,
        endYear:year,
        storeId:(this.$store.getters['user/ouId'])
      };
      return parameters;
    }

    buildYearlySaleReportChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'元');
    }

    buildYearlyNewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个');
    }
    buildYearlyRenewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个');
    }
    buildYearlyMemberDataChartOption(res:any):any{
      return this.buildMultiYearlyLineChartOption(res,'个');
    }

    buildYearlyLineChartOption(res:any,unit:string):any{
      const data = res.values.map((item:any)=>item.value);
      const option:any = {
        grid:{
          left:'60px',
          right:'0px',
          top:'10px',
          bottom:'30px'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params:any) {
            return `${params[0].name}:${params[0].value}${unit}`;
          },
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data,
          type: 'line'
        }]
      };
      return option;
    }

    buildMultiYearlyLineChartOption(res:any,unit:string):any{
      const data1 = res[0].values.map((item:any)=>item.value);
      const data2 = res[1].values.map((item:any)=>item.value);
      const data3 = res[2].values.map((item:any)=>item.value);
      const option:any = {
        grid:{
          left:'60px',
          right:'0px',
          top:'10px',
          bottom:'30px'
        },
        tooltip: {
          trigger: 'axis',
          // formatter: function (params:any) {
          //   return `${params[0].name}:${params[0].value}${unit}`;
          // },
        },
        legend: {
          x:'right',
          //y:'-10px',
          orient: 'vertical',
          data: ['新增会员', '续费会员', '体验卡']
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '新增会员',
            type: 'line',
            stack: '',
            data: data1
          },
          {
            name: '续费会员',
            type: 'line',
            stack: '',
            data: data2
          },
          {
            name: '体验卡',
            type: 'line',
            stack: '',
            data: data3
          },]
      };
      return option;
    }

    buildTestChartOption(res:any):any{
      const data = []
      for(let i = 0;i<7;i++){
        data.push(parseInt((Math.random()*1000).toFixed()));
      }
      const option:any = {
        grid:{
          left:'60px',
          right:'0px',
          top:'10px',
          bottom:'30px'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data,
          type: 'line'
        }]
      };
      return option;
    }

  }
